export const getLoyaltyQuery = () => `query
{
  profile {
    loyaltyProgram {
      platinumForLifeSince
      isPlatinumForLife
      points
      status
    }
  }
}`;
export const getLoyaltyProgramQuery = () => `
  query {
    loyaltyProgram {
      status
      threshold
    }
    loyaltyProgramSimulation {
      currency
    }
  }`;
